<template lang='pug'>
  .get-app-dropdown
    .get-app-via(v-t='"app.getVia"')
    img.qr-code(
      :src='qrCodeUrl'
      :alt='$t("app.get")'
    )
    .or(v-t='"common.or"')
    .get-app-icons
      a.ios(
        :href='iosGetAppUrl'
        rel='noopener'
        target='_blank'
      )
        span.get-app-ios-icon
      a.android(
        :href='androidGetAppUrl'
        rel='noopener'
        target='_blank'
      )
        img.get-app-android-icon(
          :src='"https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png"'
          :alt='$t("app.get")'
        )
    .app-benefits
      .benefits-text(
        v-if='getAppDesktopDropdown'
        v-html='getAppDesktopDropdown.text'
      )
      a.app-link(:href='"/pages/mobile-app"')
        span(v-t='"app.benefits"')
        span.svg-icon.arrow-small
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      getAppDesktopDropdown: state => state.layout.getAppDesktopDropdown
    }),
    androidGetAppUrl: () => vueSupport.header.androidGetAppUrl,
    iosGetAppUrl: () => vueSupport.header.iosGetAppUrl,
    i18nSiteCountryLs: () => I18n.siteCountryLs,
    qrCodeUrl () {
      return require(`@/assets/images/qr-codes/${this.i18nSiteCountryLs}_getapp.png`)
    }
  }
}
</script>

<style lang='scss' scoped>
.app-benefits {
  text-align: left;
  background-color: $grey-light;
  padding: 20px 30px;
  color: $grey-dark;
  white-space: pre-wrap;
}

.app-link {
  @include font-weight-light;
  font-size: 13px;
  display: block;
  padding-top: 10px;
  width: 160px;
}

.get-app-via {
  margin-top: 30px;
  padding-bottom: 10px;
}

.or {
  padding-top: 10px;
}

.get-app-dropdown {
  @include font-weight-medium;
  color: $black;
  text-align: center;
  font-size: 16px;
  text-transform: none;
  background-color: $white;
  border: 1px solid $grey;
  box-sizing: border-box;
  display: block;
  position: absolute;
  left: -107px;
  top: 27px;
  width: 320px;
  z-index: $zindex-dropdown;

  &::before,
  &::after {
    content: '';
    bottom: 100%;
    left: 120px;
    border: solid transparent;
    height: 0;
    width: 0;
    position: absolute;
  }

  &::before {
    border-bottom-color: #d7d7d7;
    border-width: 4px;
    margin-left: -4px;
  }

  &::after {
    border-bottom-color: $white;
    border-width: 3px;
    margin-left: -3px;
  }

  .get-app-icons {
    display: flex;
    justify-content: center;
    padding-bottom: 20px;
  }
}

.get-app-android-icon {
  height: 59px;
  vertical-align: bottom;
  margin-right: -10px;
}

.qr-code {
  height: 150px;
}

.get-app-ios-icon {
  vertical-align: top;
  margin-top: 10px;
  height: 40px;
  width: 132px;
  display: inline-block;
  background-image: url('../../../assets/images/icons/apple-store-badge.svg');
  background-size: 132px 40px;
}

.arrow-small {
  width: 10px;
  height: 10px;
  margin-left: 5px;
}
</style>
